<script setup lang="ts">
// Renders the journey answers (Proposer's Details / Cover Details / Assumptions)
// exactly as the Quote Illustration PDF's "Statement Of Fact" — same sections,
// same label/value pairs — styled to match the other confirmation cards. Each
// section offers a "Change Details" button that jumps back to its journey step.
// `note` is optional HTML authored in the tenant schema (never user input), shown
// as an alert under the section's answers when that product declares one.
defineProps<{
  sections: Array<{
    title: string
    stepId?: string
    items: Array<{ label: string; value: string }>
    note?: string
    notePDF?: string
  }>
}>()

const emit = defineEmits<{
  (e: 'change-details', stepId: string): void
}>()
</script>

<template>
  <div
    v-for="section in sections"
    :key="section.title"
    class="card-shadow card rounded-lg mb-4 overflow-hidden"
  >
    <div class="card-body p-0">
      <div class="border-bottom px-3 py-3 d-flex align-items-center justify-content-between">
        <span class="small text-uppercase text-muted font-weight-bold">{{ section.title }}</span>
        <button
          v-if="section.stepId"
          type="button"
          class="btn btn-sm btn-outline-primary"
          @click="emit('change-details', section.stepId)"
        >
          <em class="far fa-pencil mr-1"></em>Change Details
        </button>
      </div>

      <div>
        <div
          v-for="(item, index) in section.items"
          :key="index"
          class="row no-gutters border-bottom px-3 py-3 align-items-center"
        >
          <div class="col-12 col-md-6 text-muted fs-12 mb-1 mb-md-0 pr-md-3">{{ item.label }}</div>
          <div class="col-12 col-md-6 font-weight-bold text-dark">{{ item.value }}</div>
        </div>
      </div>

      <div v-if="section.note" class="px-3 py-3">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div class="alert alert-warning fs-12 mb-0" v-html="section.note"></div>
      </div>
    </div>
  </div>
</template>
